// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageLayout__container-e67bba {
  flex: 1;
  display: flex;
  max-width: 100%;
  width: 100%;
  justify-content: flex-start;
  position: relative;
}

.MessageLayout__message-is-not-selected-cb3366 {
  justify-content: center;
  margin-inline-end: -124px;
}

.MessageLayout__message-is-selected-cf6b6c {
  justify-content: center;
  margin-inline-end: 0;
}

.MessageLayout__sender-avatar-container-aa3118 {
  width: 32px;
  flex: 0 0 32px;
  margin: 0 var(--indent-12px) 0 var(--indent-8px);
}

.MessageLayout__right-container-fb7f94 {
  margin-inline-start: auto;
  display: flex;
  justify-content: flex-end;
  max-width: 100%;
  width: 100%;
  position: relative;
  padding-inline-end: 44px;
}

.MessageLayout__bubble-ea29bf {
  --chat-bubble-bg: var(--incoming-bubble-bg);
  --chat-bubble-primary: var(--incoming-bubble-primary);
  --chat-bubble-primary-soft: var(--incoming-bubble-primary_20);
  --chat-bubble-text-primary: var(--incoming-bubble-text-primary);
  --chat-bubble-text-secondary: var(--incoming-bubble-text-secondary);
  --file-ic-primary-color: var(--incoming-bubble-primary);
  --file-ic-secondary-color: var(--text-on-background);
  position: relative;
  border-radius: 16px;
  box-sizing: border-box;
  max-width: 100%;
  padding: 10px 12px;
  overflow: hidden;
  background-color: var(--chat-bubble-bg);
  border: 1px solid rgba(255, 255, 255, 0);
}

.MessageLayout__my-bubble-cfce45 {
  --chat-bubble-bg: var(--outgoing-bubble-bg);
  --chat-bubble-primary: var(--outgoing-bubble-primary);
  --chat-bubble-primary-soft: var(--outgoing-bubble-primary_20);
  --chat-bubble-text-primary: var(--outgoing-bubble-text);
  --chat-bubble-text-secondary: var(--outgoing-bubble-text_70);
  --file-ic-primary-color: var(--outgoing-bubble-primary);
  --file-ic-secondary-color: var(--outgoing-bubble-on-primary);
}

.MessageLayout__squared-top-left-corner-c118df {
  border-top-left-radius: 4px;
}

.MessageLayout__squared-bottom-left-corner-ab9bae {
  border-bottom-left-radius: 4px;
}

.MessageLayout__squared-top-right-corner-de69ca {
  border-top-right-radius: 4px;
}

.MessageLayout__squared-bottom-right-corner-a15200 {
  border-bottom-right-radius: 4px;
}

.MessageLayout__bubble-wrapper-ea70f2 {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-width: var(--message-bubble-max-width);
}

.MessageLayout__channel-bubble-fb063a {
  min-width: var(--message-bubble-max-width);
}

.MessageLayout__channel-bubble-fb063a .MessageLayout__my-bubble-cfce45 {
  --chat-bubble-bg: var(--incoming-bubble-bg);
  --chat-bubble-primary: var(--incoming-bubble-primary);
  --chat-bubble-primary-soft: var(--incoming-bubble-primary_20);
  --chat-bubble-text-primary: var(--incoming-bubble-text-primary);
  --chat-bubble-text-secondary: var(--incoming-bubble-text-secondary);
}

.MessageLayout__reactions-eec302 {
  margin-top: 4px;
  padding-bottom: 4px;
}

.MessageLayout__hide-a82fba {
  visibility: hidden;
}

.MessageLayout__bubble-ea29bf a {
  color: var(--chat-bubble-primary);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/MessageLayout/MessageLayout.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;EACA,kBAAA;AACF;;AAEA;EACE,uBAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;EACA,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,gDAAA;AACF;;AAEA;EACE,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AACF;;AAEA;EACE,2CAAA;EACA,qDAAA;EACA,6DAAA;EACA,+DAAA;EACA,mEAAA;EACA,uDAAA;EACA,oDAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;EACA,wCAAA;AACF;;AAEA;EACE,2CAAA;EACA,qDAAA;EACA,6DAAA;EACA,uDAAA;EACA,4DAAA;EACA,uDAAA;EACA,4DAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,0CAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,2CAAA;EACA,qDAAA;EACA,6DAAA;EACA,+DAAA;EACA,mEAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,iCAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  max-width: 100%;\n  width: 100%;\n  justify-content: flex-start;\n  position: relative;\n}\n\n.message-is-not-selected {\n  justify-content: center;\n  margin-inline-end: -124px;\n}\n\n.message-is-selected {\n  justify-content: center;\n  margin-inline-end: 0;\n}\n\n.sender-avatar-container {\n  width: 32px;\n  flex: 0 0 32px;\n  margin: 0 var(--indent-12px) 0 var(--indent-8px);\n}\n\n.right-container {\n  margin-inline-start: auto;\n  display: flex;\n  justify-content: flex-end;\n  max-width: 100%;\n  width: 100%;\n  position: relative;\n  padding-inline-end: 44px;\n}\n\n.bubble {\n  --chat-bubble-bg: var(--incoming-bubble-bg);\n  --chat-bubble-primary: var(--incoming-bubble-primary);\n  --chat-bubble-primary-soft: var(--incoming-bubble-primary_20);\n  --chat-bubble-text-primary: var(--incoming-bubble-text-primary);\n  --chat-bubble-text-secondary: var(--incoming-bubble-text-secondary);\n  --file-ic-primary-color: var(--incoming-bubble-primary);\n  --file-ic-secondary-color: var(--text-on-background);\n  position: relative;\n  border-radius: 16px;\n  box-sizing: border-box;\n  max-width: 100%;\n  padding: 10px 12px;\n  overflow: hidden;\n  background-color: var(--chat-bubble-bg);\n  border: 1px solid #ffffff00;\n}\n\n.my-bubble {\n  --chat-bubble-bg: var(--outgoing-bubble-bg);\n  --chat-bubble-primary: var(--outgoing-bubble-primary);\n  --chat-bubble-primary-soft: var(--outgoing-bubble-primary_20);\n  --chat-bubble-text-primary: var(--outgoing-bubble-text);\n  --chat-bubble-text-secondary: var(--outgoing-bubble-text_70);\n  --file-ic-primary-color: var(--outgoing-bubble-primary);\n  --file-ic-secondary-color: var(--outgoing-bubble-on-primary);\n}\n\n.squared-top-left-corner {\n  border-top-left-radius: 4px;\n}\n\n.squared-bottom-left-corner {\n  border-bottom-left-radius: 4px;\n}\n\n.squared-top-right-corner {\n  border-top-right-radius: 4px;\n}\n\n.squared-bottom-right-corner {\n  border-bottom-right-radius: 4px;\n}\n\n.bubble-wrapper {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  max-width: var(--message-bubble-max-width);\n}\n\n.channel-bubble {\n  min-width: var(--message-bubble-max-width);\n}\n\n.channel-bubble .my-bubble {\n  --chat-bubble-bg: var(--incoming-bubble-bg);\n  --chat-bubble-primary: var(--incoming-bubble-primary);\n  --chat-bubble-primary-soft: var(--incoming-bubble-primary_20);\n  --chat-bubble-text-primary: var(--incoming-bubble-text-primary);\n  --chat-bubble-text-secondary: var(--incoming-bubble-text-secondary);\n}\n\n.reactions {\n  margin-top: 4px;\n  padding-bottom: 4px;\n}\n\n.hide {\n  visibility: hidden;\n}\n\n.bubble a {\n  color: var(--chat-bubble-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MessageLayout__container-e67bba`,
	"message-is-not-selected": `MessageLayout__message-is-not-selected-cb3366`,
	"messageIsNotSelected": `MessageLayout__message-is-not-selected-cb3366`,
	"message-is-selected": `MessageLayout__message-is-selected-cf6b6c`,
	"messageIsSelected": `MessageLayout__message-is-selected-cf6b6c`,
	"sender-avatar-container": `MessageLayout__sender-avatar-container-aa3118`,
	"senderAvatarContainer": `MessageLayout__sender-avatar-container-aa3118`,
	"right-container": `MessageLayout__right-container-fb7f94`,
	"rightContainer": `MessageLayout__right-container-fb7f94`,
	"bubble": `MessageLayout__bubble-ea29bf`,
	"my-bubble": `MessageLayout__my-bubble-cfce45`,
	"myBubble": `MessageLayout__my-bubble-cfce45`,
	"squared-top-left-corner": `MessageLayout__squared-top-left-corner-c118df`,
	"squaredTopLeftCorner": `MessageLayout__squared-top-left-corner-c118df`,
	"squared-bottom-left-corner": `MessageLayout__squared-bottom-left-corner-ab9bae`,
	"squaredBottomLeftCorner": `MessageLayout__squared-bottom-left-corner-ab9bae`,
	"squared-top-right-corner": `MessageLayout__squared-top-right-corner-de69ca`,
	"squaredTopRightCorner": `MessageLayout__squared-top-right-corner-de69ca`,
	"squared-bottom-right-corner": `MessageLayout__squared-bottom-right-corner-a15200`,
	"squaredBottomRightCorner": `MessageLayout__squared-bottom-right-corner-a15200`,
	"bubble-wrapper": `MessageLayout__bubble-wrapper-ea70f2`,
	"bubbleWrapper": `MessageLayout__bubble-wrapper-ea70f2`,
	"channel-bubble": `MessageLayout__channel-bubble-fb063a`,
	"channelBubble": `MessageLayout__channel-bubble-fb063a`,
	"reactions": `MessageLayout__reactions-eec302`,
	"hide": `MessageLayout__hide-a82fba`
};
module.exports = ___CSS_LOADER_EXPORT___;
